<div [formGroup]="afterSalesDetailForm">
  <pas-system-process [cancelButton]="false" #processComponent></pas-system-process>
  <div class="row">
    <div class="col-12">
      <h2>
        <b>{{ 'AFTER_SALES_DETAIL_REPORT_NO' | translate }} {{ afterSalesDetailForm.get('reportId').value }}</b>
      </h2>
    </div>
    <div class="col-12 col-lg-4">
      <div class="row">
        <table>
          <tr>
            <td class="noPadding col-6">
              <label>
                <b>{{ 'AFTER_SALES_DETAIL_REPORT_STATE' | translate }}</b>
              </label>
            </td>
            <td class="noPadding col-6">
              <label id="reportStateLabel">{{ afterSalesDetailForm.get('reportState').value }}</label>
            </td>
          </tr>
          <tr>
            <td class="noPadding col-6">
              <label>
                <b>{{ 'AFTER_SALES_DETAIL_ERROR_CODE' | translate }}</b>
              </label>
            </td>
            <td class="noPadding col-6">
              <label>{{ afterSalesDetailForm.get('errorCode').value }}</label>
            </td>
          </tr>
          <tr>
            <td class="noPadding col-6">
              <label>
                <b>{{ 'AFTER_SALES_DETAIL_SUPPLIER' | translate }}</b>
              </label>
            </td>
            <td class="noPadding col-6">
              <label>
                {{ afterSalesDetailForm.get('supplierNo').value }}
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <div class="row">
        <table>
          <tr>
            <td class="noPadding col-6">
              <label>
                <b>{{ 'AFTER_SALES_DETAIL_RECOURSE_RELEVANT' | translate }}</b>
              </label>
            </td>
            <td class="noPadding col-6">
              <pas-checkbox
                [formControl]="$any(afterSalesDetailForm.get('recourseRelevant'))"
                [disabled]="afterSalesDetailForm.get('recourseRelevant').disabled"
                size="small"></pas-checkbox>
            </td>
          </tr>
          <tr>
            <td class="noPadding col-6">
              <label>
                <b>{{ 'AFTER_SALES_DETAIL_ERROR_CLASS' | translate }}</b>
              </label>
            </td>
            <td class="noPadding col-6">
              <label>{{ afterSalesDetailForm.get('errorClass').value }}</label>
            </td>
          </tr>
          <tr>
            <td class="noPadding col-6">
              <label>
                <b>{{ 'AFTER_SALES_DETAIL_SUPPLIER_NAME' | translate }}</b>
              </label>
            </td>
            <td class="noPadding col-6">
              <label>{{ afterSalesDetailForm.get('supplierName').value }}</label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="clearfix hidden-sm-up"></div>
    <div class="col-12 col-lg-4">
      <div class="row">
        <table>
          <tr>
            <td class="noPadding col-6">
              <label>
                <b>{{ 'AFTER_SALES_DETAIL_CREATE_DATE' | translate }}</b>
              </label>
            </td>
            <td class="noPadding col-6">
              <label>{{ afterSalesDetailForm.get('reportCreationDate').value }}</label>
            </td>
          </tr>
          <tr>
            <td class="noPadding col-6">
              <label>
                <b>{{ 'AFTER_SALES_DETAIL_ERROR_DESCRIPTION' | translate }}</b>
              </label>
            </td>
            <td class="noPadding col-6">
              <label>{{ afterSalesDetailForm.get('errorDescription').value }}</label>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <!-- RECOURSE COSTS ACCORDION -->
  <pas-accordion [isClosed]="false" title="{{ 'AFTER_SALES_DETAIL_ACCORDION_TITLE_RECOURSE_COST' | translate }}">
    <ng-template pasAccordionBody>
      <div class="col-12">
        <div class="row">
          <div class="col-4"></div>
          <div class="col-2 additional-cost-category">
            <label>
              <b>{{ 'AFTER_SALES_DETAIL_ADDITIONAL_COST_HEADER_CATEGORY' | translate }}</b>
            </label>
          </div>
          <div class="col-2 additional-cost-comment">
            <label>
              <b>{{ 'AFTER_SALES_DETAIL_ADDITIONAL_COST_HEADER_COMMENT' | translate }}</b>
            </label>
          </div>
          <div class="col-2 additional-cost">
            <label>
              <b>{{ 'AFTER_SALES_DETAIL_ADDITIONAL_COST_HEADER_EUR' | translate }}</b>
            </label>
          </div>
          @if (additionalCostsButtonsVisible()) {
            <div class="col-2 text-right" style="padding-right: 35px">
              <pas-button
                (click)="onNewAdditionalCost()"
                id="addAdditionalCostBtn"
                icon="add_circle"
                ui-test-id="addAdditionalCostBtn"
                text="{{ 'AFTER_SALES_DETAIL_BUTTON_ADDITIONAL_COST' | translate }}"></pas-button>
            </div>
          }
        </div>
      </div>

      <div class="col-12">
        <div class="row">
          <div class="col-4"></div>
          <div class="col-8 text-right">
            <hr />
          </div>
        </div>
      </div>

      @if (sizeOfAditionalCosts === 0) {
        <br />
        <div class="row col-12">
          <div class="col-4"></div>
          <div class="col-8" style="padding-top: 5px; text-align: center">
            <label>{{ 'AFTER_SALES_DETAIL_ADDITIONAL_COST_BODY_NO_DATA' | translate }}</label>
          </div>
        </div>
        <br />
      }
      @if (sizeOfAditionalCosts > 0) {
        <div class="col-12">
          @for (item of additionalCostFormArray.controls; track item; let i = $index) {
            <div formArrayName="additionalCostItems">
              <div [formGroupName]="i">
                <div class="row">
                  <div class="col-4"></div>
                  <div class="col-8">
                    <div class="col-12">
                      <div class="row">
                        <label class="col-3 additional-cost-item-cat-com" id="formArrayControlCategory-{{ i }}">
                          {{ item.get('categoryTranslated').value }}
                        </label>
                        <label class="col-4 additional-cost-item-cat-com" id="formArrayControlComment-{{ i }}">
                          {{ item.get('comment').value }}
                        </label>
                        <label class="col-2 additional-cost-item" id="formArrayControlAdditionalCost-{{ i }}">
                          {{ item.get('additionalCost').value }}
                        </label>
                        @if (additionalCostsButtonsVisible()) {
                          <div class="col-2 text-right after-sales-edit-btn">
                            <pas-button
                              (click)="onEditAdditionalCost(i)"
                              class="additional-cost-edit-button"
                              id="editAdditionalCostRow-{{ i }}"
                              style="padding-right: 5px"
                              icon="mode_edit"></pas-button>
                            <pas-button
                              (click)="onDeleteAdditionalCost(i)"
                              class="additional-cost-delete-button delete"
                              id="deleteAdditionalCostRow-{{ i }}"
                              icon="close"></pas-button>
                          </div>
                        }
                        <br />
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }

      <div class="col-12">
        <div class="row">
          <div class="col-4"></div>
          <div class="col-8 text-right">
            <hr class="solid-black" />
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="row">
          <div class="col-4"></div>
          <div class="col-8">
            <div class="col-12">
              <div class="row">
                <div class="col-3">
                  <label>
                    <b>{{ 'AFTER_SALES_DETAIL_ADDITIONAL_COST_SUM' | translate }}</b>
                  </label>
                </div>
                <div class="col-2"></div>
                <div class="col-4 text-right">
                  <label class="select-control label-formatted">
                    <b id="additionalCostsSum" ui-test-id="additionalCostsSum">{{ formattedAdditionalCostsSum }}</b>
                  </label>
                </div>
                <div class="col-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="row">
          <div class="col-4"></div>
          <div class="col-8">
            <div class="col-12">
              <div class="row">
                <div class="col-3">
                  <label>
                    <b>{{ 'AFTER_SALES_DETAIL_RECOURSE_COST_RATE' | translate }}</b>
                  </label>
                </div>
                <div class="col-2"></div>
                <div class="col-4 text-right">
                  <label class="select-control label-formatted">
                    <b id="recourseCostRate">{{ formattedRecourseCostRate }}</b>
                  </label>
                </div>
                <div class="col-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="row">
          <div class="col-4"></div>
          <div class="col-8 text-right">
            <hr class="solid-black" />
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="row">
          <div class="col-4"></div>
          <div class="col-8">
            <div class="col-12">
              <div class="row">
                <div class="col-3">
                  <label>
                    <b>{{ 'AFTER_SALES_DETAIL_TOTAL_COST' | translate }}</b>
                  </label>
                </div>
                <div class="col-2"></div>
                <div class="col-4 text-right">
                  <label class="select-control label-formatted">
                    <b id="totalCosts" ui-test-id="totalCosts">{{ formattedTotalCosts }}</b>
                  </label>
                </div>
                <div class="col-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </pas-accordion>

  <!-- RECOURSE BOOKINGS -->
  <pas-accordion [isClosed]="false" title="{{ 'AFTER_SALES_DETAIL_ACCORDION_TITLE_RECOURSE_BOOKINGS' | translate }}">
    <ng-template pasAccordionBody>
      <div class="col-12">
        <ag-grid-angular
          [gridOptions]="bookingGridOptions"
          [columnDefs]="bookingTableColumnDefs"
          [defaultColDef]="defaultColDef"
          [components]="frameworkComponents"
          [getContextMenuItems]=""
          [domLayout]="data?.bookings?.length > 8 ? 'normal' : 'autoHeight'"
          [style.height]="data?.bookings?.length > 8 ? '390px' : 'none'"
          (firstDataRendered)="onFirstDataRendered($event)"
          (gridReady)="onBookingGridReady($event)"
          (gridSizeChanged)="onGridSizeChanged($event)"
          class="ag-theme-alpine_customize"
          id="afterSalesRecourseBookingTable"
          style="width: 100%"></ag-grid-angular>
      </div>
      <br />
      <div class="row col-12">
        <div class="col-2">
          <label style="padding-left: 11px">
            <b>{{ 'AFTER_SALES_DETAIL_TABLE_BOOKING_TOTAL_AMOUNT' | translate }}</b>
          </label>
        </div>
        <div class="col-2">
          <label
            [ngClass]="{ 'red-characters': afterSalesDetailForm.get('totalAmountForBookings').value < 0 }"
            style="float: right; padding-right: 87px">
            <b>{{ afterSalesDetailForm.get('totalAmountForBookings').value }}</b>
          </label>
        </div>
      </div>
    </ng-template>
  </pas-accordion>
</div>

<pas-sidebar-holder [hasNavbar]="true">
  <div class="sidebar-contents">
    <ng-container>
      <div class="sidebar-element sidebar-row">
        <ul class="navbar-nav">
          @if (isCreateManualBookingVisible()) {
            <li class="nav-item">
              <a (click)="onBtnCreateManualBooking()" class="nav-link link-sidebar">
                <i class="material-icons">add_circle_outline</i>
                <span class="hidden-md-down" ui-test-id="createManualBookingBtn">
                  {{ 'AFTER_SALES_DETAIL_BUTTON_CREATE_MANUAL_BOOKING' | translate }}
                </span>
              </a>
            </li>
          }
          <li class="nav-item">
            <a (click)="onBtnCancel()" class="nav-link link-sidebar">
              <i class="material-icons">cancel</i>
              <span class="hidden-md-down" ui-test-id="cancelBtn">{{ 'CANCEL' | translate }}</span>
            </a>
          </li>
        </ul>
      </div>
    </ng-container>
  </div>
</pas-sidebar-holder>

<ng-template #AdditionalCostsDialogTemplate>
  <tur-generic-modal-content
    [acceptanceAllowed]="isAcceptanceAllowed()"
    (confirm)="onAcceptAdditionalCostsDialog()"
    (cancel)="onCloseAdditionalCostsDialog()"
    id="AdditionalCostsDialog"
    confirmationMessage=""
    ui-test-id="additionalCostsDialog"
    modalTitle="{{ 'AFTER_SALES_DETAIL_ADDITIONAL_COST_DIALOG_TITLE' | translate }}"
    acceptButtonLbl="{{ 'SAVE' | translate }}"
    cancelButtonLbl="{{ 'CANCEL' | translate }}">
    <div [formGroup]="additionalCostDialogForm">
      <div class="col-12">
        <div class="row">
          <pas-select
            [(ngModel)]="selectedCategory"
            [options]="additionalCostsCategoryDropdownList"
            [formControl]="$any(additionalCostDialogForm.get('category'))"
            [validationMessages]="validationMessages"
            class="col-4"
            id="additionalCostsDialogCategorySelect"
            placeholder="{{ 'CHOOSE_ONE' | translate }}"
            ui-test-id="additionalCostsDialogCategorySelect"
            subLabel="{{ 'AFTER_SALES_DETAIL_ADDITIONAL_COST_DIALOG_CATEGORY' | translate }}"></pas-select>
          <pas-input
            [maxLength]="250"
            [formControl]="$any(additionalCostDialogForm.get('comment'))"
            class="col-5"
            id="additionalCostsDialogComment"
            ui-test-id="additionalCostsDialogComment"
            subLabel="{{ 'AFTER_SALES_DETAIL_ADDITIONAL_COST_DIALOG_COMMENT' | translate }}"></pas-input>
          <pas-input-number
            [hasClearBtn]="false"
            [minimumValue]="0"
            [maximumValue]="30000"
            [maxLength]="8"
            [decimalCount]="2"
            [decimalSeparator]="decimalSeparator"
            [formControl]="$any(additionalCostDialogForm.get('additionalCost'))"
            [validationMessages]="validationMessages"
            class="col-3 pull-right nowrap"
            id="additionalCostsDialogAdditionalCostAmount"
            ui-test-id="additionalCostsDialogAdditionalCostAmount"
            subLabel="{{ 'AFTER_SALES_DETAIL_ADDITIONAL_COST_DIALOG_EUR' | translate }}"></pas-input-number>
        </div>
      </div>
      <div class="col-12">
        <div class="row" style="padding: 0px 315px">
          <div class="d-flex justify-content-center">
            @if (spinnerActive) {
              <pas-spinner [size]="'small'"></pas-spinner>
            }
          </div>
        </div>
      </div>
    </div>
  </tur-generic-modal-content>
</ng-template>
